module.exports = __webpack_public_path__ + "media/illustrations/no-patient-registered-2888b118.png";